import axios from 'axios';
const baseURL = 'https://cms.hochspannung.ch';

axios.interceptors.request.use(config => {
  const params = new URLSearchParams(document.location.search.substring(1));
  const token = params.get('token');
  if (token) {
    config.params = { ...config.params, token };
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// /api/home is used by the app shell, the header and the home page; share one request.
let homeRequest = null;
function getHome() {
  if (!homeRequest) {
    homeRequest = axios.get(`${baseURL}/api/home`).catch(error => {
      homeRequest = null;
      throw error;
    });
  }
  return homeRequest;
}

export {
  axios as ax,
  baseURL,
  getHome,
};
